import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/global.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* ErrorBoundary catches render-time exceptions (e.g. pending maplibre
        callbacks firing on a torn-down map mid-screen-transition) so the
        user sees a recovery panel instead of a black screen. */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
